<div class="reportsPage">
  <h2>Reports</h2>

  <div class="reportSelector">
    <label for="reportSelect">Report:</label>
    <select id="reportSelect"
            name="reportSelect"
            class="inputField"
            [(ngModel)]="selectedReportCode">
      <option [ngValue]="undefined" disabled>Please Select</option>
      @for (report of reports; track report.code) {
        <option [ngValue]="report.code">{{ report.description }}</option>
      }
    </select>

    <button type="button"
            class="runButton"
            [disabled]="!selectedReportCode || running()"
            (click)="runReport()">
      @if (running()) { Running... } @else { Run Report }
    </button>
  </div>

  @if (errorMessage()) {
    <div class="errorMessage">{{ errorMessage() }}</div>
  }
</div>
